import { useCallback, useMemo } from 'react';
import { useAppSelector } from '../redux';
import useMap from './useMap';

// Based on buildPrintMapUrlParams in the monolith
const usePrintUrlSearchParams = () => {
  const map = useMap();
  const { baseStyleId, dynamicStyleIds, staticStyleIds } = useAppSelector(state => ({
    baseStyleId: state.map.baseStyleId,
    dynamicStyleIds: state.map.dynamicStyleIds,
    staticStyleIds: state.map.staticStyleIds
  }));

  const mapType = useMemo(() => {
    if (baseStyleId === 'alltrailsOutdoorsV3') {
      // This updated style is not supported on the print page, use the legacy version:
      return 'alltrailsOutdoorsV2';
    }
    if (baseStyleId === 'alltrailsSatelliteV2') {
      // This updated style is not supported on the print page, use the legacy version:
      return 'alltrailsSatellite';
    }
    if (baseStyleId === 'worldparks' || baseStyleId === 'roadmap' || baseStyleId === 'alltrailsOutdoorsV2') {
      // These styles are supported on the print page
      return baseStyleId;
    }
    // Everything else falls back to the default print style
    return 'alltrailsOutdoorsV2';
  }, [baseStyleId]);

  const getParams = useCallback(() => {
    const params = new URLSearchParams({});

    if (!map) {
      return params;
    }

    const center = map.getCenter();
    params.append('map_center_lat', String(center.lat));
    params.append('map_center_lon', String(center.lng));
    params.append('map_zoom', String(map.getZoom()));

    params.append('map_type', mapType);
    [...dynamicStyleIds, ...staticStyleIds].forEach(overlay => params.append('enabled_overlays[]', overlay));

    return params;
  }, [dynamicStyleIds, map, mapType, staticStyleIds]);

  return getParams;
};

export default usePrintUrlSearchParams;
